/**
 * Compress a base64 image to stay under maxBytes (decoded binary size).
 * Uses canvas to resize + JPEG compress. Returns a new base64 data URL.
 */
export function compressImage(base64: string, maxBytes = 3 * 1024 * 1024): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      let { width, height } = img

      // Scale down if very large
      const MAX_DIM = 1920
      if (width > MAX_DIM || height > MAX_DIM) {
        const ratio = Math.min(MAX_DIM / width, MAX_DIM / height)
        width = Math.round(width * ratio)
        height = Math.round(height * ratio)
      }

      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')!
      ctx.drawImage(img, 0, 0, width, height)

      // Binary-search quality until under maxBytes
      let lo = 0.3, hi = 0.92, best = ''
      for (let i = 0; i < 8; i++) {
        const mid = (lo + hi) / 2
        const dataUrl = canvas.toDataURL('image/jpeg', mid)
        const bytes = Math.round((dataUrl.length - dataUrl.indexOf(',') - 1) * 0.75)
        if (bytes <= maxBytes) {
          best = dataUrl
          lo = mid
        } else {
          hi = mid
        }
      }

      if (!best) {
        // Last resort: smallest quality
        best = canvas.toDataURL('image/jpeg', 0.3)
      }

      resolve(best)
    }
    img.onerror = reject
    img.src = base64
  })
}
